import apiClient from "./client";
import { unwrapApiResponse, unwrapApiResult } from "../utils/apiError";
import { BINARY_REQUEST_CONFIG, saveAxiosFile } from "../utils/download";

export const classSubjectAPI = {
  getAll: async () => {
    const response = await apiClient.get("/teacher/class-subjects");
    return unwrapApiResponse(response);
  },

  getById: async (id) => {
    const response = await apiClient.get(`/teacher/class-subjects/${id}`);
    return unwrapApiResponse(response);
  },

  getAttendance: async (
    classSubjectId,
    { startDate, endDate, studentId, status } = {}
  ) => {
    const response = await apiClient.get(`/teacher/class-subjects/${classSubjectId}/attendance`, {
      params: {
        startDate,
        endDate,
        ...(studentId ? { studentId } : {}),
        ...(status ? { status } : {}),
      },
    });
    return unwrapApiResponse(response);
  },

  initializeAttendanceDay: async (classSubjectId, { date }) => {
    const response = await apiClient.post(
      `/teacher/class-subjects/${classSubjectId}/attendance/initialize-day`,
      { date }
    );
    return unwrapApiResponse(response);
  },

  getAttendanceDay: async (classSubjectId, { date }) => {
    const response = await apiClient.get(
      `/teacher/class-subjects/${classSubjectId}/attendance/day`,
      { params: { date } }
    );
    return unwrapApiResponse(response);
  },

  exportAttendance: async (
    classSubjectId,
    { startDate, endDate, studentId, status } = {}
  ) => {
    const response = await apiClient.get(
      `/teacher/class-subjects/${classSubjectId}/attendance/export`,
      {
        params: {
          startDate,
          endDate,
          ...(studentId ? { studentId } : {}),
          ...(status ? { status } : {}),
        },
        ...BINARY_REQUEST_CONFIG,
      }
    );

    saveAxiosFile(
      response,
      `attendance-${classSubjectId}-${startDate}-${endDate}.xls`
    );
  },

  updateStudentAttendance: async ({
    classSubjectId,
    studentId,
    date,
    status,
    description = "",
  }) => {
    const response = await apiClient.patch(
      `/teacher/class-subjects/${classSubjectId}/students/${studentId}/attendance`,
      { date, status, description }
    );
    return unwrapApiResponse(response);
  },

  getLevels: async (classSubjectId, { startDate, endDate, studentId } = {}) => {
    const response = await apiClient.get(`/teacher/class-subjects/${classSubjectId}/levels`, {
      params: {
        startDate,
        endDate,
        ...(studentId ? { studentId } : {}),
      },
    });
    return unwrapApiResponse(response);
  },

  exportLevels: async (classSubjectId, { startDate, endDate, studentId } = {}) => {
    const response = await apiClient.get(
      `/teacher/class-subjects/${classSubjectId}/levels/export`,
      {
        params: {
          startDate,
          endDate,
          ...(studentId ? { studentId } : {}),
        },
        ...BINARY_REQUEST_CONFIG,
      }
    );

    saveAxiosFile(response, "class-levels.xls");
  },

  deleteLevelHistory: async ({ classSubjectId, historyId }) => {
    const response = await apiClient.delete(
      `/teacher/class-subjects/${classSubjectId}/level-histories/${historyId}`
    );
    return unwrapApiResult(response);
  },

  getDisciplines: async (classSubjectId, { startDate, endDate, studentId } = {}) => {
    const response = await apiClient.get(
      `/teacher/class-subjects/${classSubjectId}/disciplines`,
      {
        params: {
          startDate,
          endDate,
          ...(studentId ? { studentId } : {}),
        },
      }
    );
    return unwrapApiResponse(response);
  },

  exportDisciplines: async (classSubjectId, { startDate, endDate, studentId } = {}) => {
    const response = await apiClient.get(
      `/teacher/class-subjects/${classSubjectId}/disciplines/export`,
      {
        params: {
          startDate,
          endDate,
          ...(studentId ? { studentId } : {}),
        },
        ...BINARY_REQUEST_CONFIG,
      }
    );

    saveAxiosFile(response, "class-disciplines.xlsx");
  },

  deleteDisciplineHistory: async ({ classSubjectId, historyId }) => {
    const response = await apiClient.delete(
      `/teacher/class-subjects/${classSubjectId}/discipline-histories/${historyId}`
    );
    return unwrapApiResult(response);
  },
};
